import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=e9699ade"
var script = {}
import style0 from "./contacts.vue?vue&type=style&index=0&id=e9699ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports